import React from 'react';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { abbreviateName, formatCreatedAt } from '../../util/circleHelper';
import css from './SearchInGroupPostCard.module.css';
import InReviewCard from '../InReviewCard/InReviewCard';

const SearchInGroupPostCard = props => {
  const { record, handleSearchItemClick } = props;
  const {
    author,
    name,
    created_at,
    highlighted_name,
    highlighted_body,
    body,
    flagged_for_approval_at,
    slug,
    id,
    space,
  } = record ?? {};

  const { name: authorName, avatar_url } = author ?? {};

  return (
    <div className={css.listWrapper} onClick={() => handleSearchItemClick(record)}>
      <div className={css.topWrapper}>
        {avatar_url ? (
          <ResponsiveImage className={css.imageWrapper} alt={'FeedCoverPhoto'} imagewithURL={avatar_url} />
        ) : (
          <div className={css.nameWrapper}>{abbreviateName(authorName)}</div>
        )}
        <span className={css.timingZone}>{formatCreatedAt(created_at)}</span>
        {flagged_for_approval_at ? <span className={css.reviewText}><InReviewCard /></span> : null}
      </div>
      {/* title */}
      <div
  className={css.title}
  dangerouslySetInnerHTML={{
    __html: highlighted_name?.replace(/<mark>(.*?)<\/mark>/g, '<mark style="background-color: #C0D8F4; color: black;">$1</mark>'),
  }}
/>
      {/* highlighted_body */}
      <div className={css.description}  dangerouslySetInnerHTML={{ __html: highlighted_body?.replace(/<mark>(.*?)<\/mark>/g, '<mark style="background-color: #C0D8F4; color: black;">$1</mark>') }} />
    </div>
  );
};

export default SearchInGroupPostCard;
